// @flow
import { List, Map } from 'immutable';
import { Reducer }   from '../../Reducer';

import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateDone,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess
}                 from '../../utils';
import * as TYPES from './types';

const DEFAULT_STATE = Map({
    busy:        false,
    error:       null,
    items:       List([]),
    active:      null,
    activeError: null,
    item:        null,
});

export default class SalesmanReducer extends Reducer {
    NAME = 'Salesman';

    alias = {
        [ TYPES.SALESMAN_GET_REQUEST ]: 'onGetRequest',
        [ TYPES.SALESMAN_GET_SUCCESS ]: 'onGetSuccess',
        [ TYPES.SALESMAN_GET_FAIL ]:    'onGetFailure',

        [ TYPES.SALESMAN_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.SALESMAN_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.SALESMAN_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.SALESMAN_CREATE_DONE ]:    'onItemCreateDone',

        [ TYPES.SALESMAN_LOAD_REQUEST ]: 'onItemLoadRequest',
        [ TYPES.SALESMAN_LOAD_SUCCESS ]: 'onItemLoadSuccess',
        [ TYPES.SALESMAN_LOAD_FAIL ]:    'onItemLoadFailure',

        [ TYPES.SALESMAN_UPDATE_REQUEST ]: 'onItemUpdateRequest',
        [ TYPES.SALESMAN_UPDATE_SUCCESS ]: 'onItemUpdateSuccess',
        [ TYPES.SALESMAN_UPDATE_FAIL ]:    'onItemUpdateFailure',
        [ TYPES.SALESMAN_UPDATE_DONE ]:    'onItemUpdateDone',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateDone = simpleOnItemUpdateDone(DEFAULT_STATE);

}
